import { render } from "lit-html";
import { FormField } from "../zhi-form-field/zhi-form-field";

class ZhiTextInput extends FormField {

  get inputType() {
    const allowedTypes = ["text", "email"];
    const attrValue = this.getAttribute("type");
    if (attrValue === null) return "text";
    return allowedTypes.includes(attrValue) ? attrValue : "text";
  }

  get pattern() {
    return this.getAttribute("pattern") || undefined;
  }

  async renderComponent() {
    const { textInputTemplate } = await import("./zhi-text-input.template");
    render(textInputTemplate({ component: this }), this);
  }
}

customElements.define("zhi-text-input", ZhiTextInput);